// import { contracts } from "environments/environment"
import * as abi from "../abi/index"


export const CONTRACTS_ABI = (): IContract[] => {
    return [
        {
            name: eContracts.KMONFT,
            abi: abi.contractAbiV4Json,
        },
        {
            name: eContracts.KMONFTV2,
            abi: abi.contractAbiDiamond,
        },
        {
            name: eContracts.KMONToken,
            abi: abi.tokenAbiJson,
        },
        {
            name: eContracts.Lottery,
            abi: abi.lotteryAbiJson,
        },
        {
            name: eContracts.LotteryOld,
            abi: abi.lotteryAbiJson,
        },
        {
            name: eContracts.StakingRewards,
            abi: abi.stakingRewardsAbiJson,
        },
        {
            name: eContracts.WBNB,
            abi: abi.BNBAbi,
        },
        {
            name: eContracts.Lootbox,
            abi: abi.lootboxAbi,
        },
        {
            name: eContracts.MarketplaceProxy,
            abi: abi.marketplaceAbi
        },
        {
            name: eContracts.ERC721Bid,
            abi: abi.ERC721 //TO VERIFY
        },
        {
            name: eContracts.Playdex,
            abi: abi.playdexAbi
        },
        {
            name: eContracts.PancakeV2,
            abi: abi.pancakeV2Abi
        },
        {
            name: eContracts.StakingRewardsLP,
            abi: abi.stakingRewardsAbiJson
        },
        {
            name: eContracts.StakingRewardsOld,
            abi: abi.stakingRewardsAbiJson
        },
        {
            name: eContracts.LiquidityProvider,
            abi: abi.pancakeV2Pair
        },
        {
            name: eContracts.MerkleBNB,
            abi: abi.merkleClaimAbi
        },
        {
            name: eContracts.AirDropMerkle,
            abi: abi.merkleAirdrop
        },
        {
            name: eContracts.AirDropMerkle2,
            abi: abi.merkleAirdrop
        },
        {
            name: eContracts.BuyMisteryBoxMerkle,
            abi: abi.merkleClaimAbi
        },
        {
            name: eContracts.BUSD,
            abi: abi.tokenAbiJson
        }
    ]
}

export enum eContracts {
    KMONToken = 'KMONToken',
    KMONFT = 'KMONFT',
    KMONFTV2 = 'KMONFTV2',
    MarketplaceProxy = 'MarketplaceProxy',
    ERC721Bid = 'ERC721Bid',
    Lootbox = 'Lootbox',
    WBNB = 'WBNB',
    BUSD = 'BUSD',
    StakingRewards = 'StakingRewards',
    Lottery = 'Lottery',
    LotteryOld = 'LotteryOld',
    Playdex = 'Playdex',
    PancakeV2 = 'PancakeV2',
    StakingRewardsLP = 'StakingRewardsLP',
    StakingRewardsOld = 'StakingRewardsOld',
    LiquidityProvider = 'LiquidityProvider',//To check if it is still used
    MerkleBNB = 'MerkleBNB',
    MerkleEggHunt = 'MerkleEggHunt',
    AirDropMerkle = 'AirDropMerkle',
    AirDropMerkle2 = 'AirDropMerkle2',
    BuyMisteryBoxMerkle = 'BuyMisteryBoxMerkle'
}

export interface IContract {
    name: eContracts,
    abi: any,
    // address: string
}

export enum eNetworkName {
    bsc = 'bsc',
    rinkeby = 'rinkeby',
    chapel = 'chapel'
}

export const contractAddress = {
    bsc: {
        KMONToken: "0xc732b6586a93b6b7cf5fed3470808bc74998224d",
        KMONFT: "0xc33d69a337b796a9f0f7588169cd874c3987bde9",
        KMONFTV2: "0x04b0f7d5cb2ce4688497f2525748fb7a9affa394",
        MarketplaceProxy: "0x61BB68bcA6eB9DCb434A52fBCB999a353c283aFF",
        ERC721Bid: "0x51EeD96088ED0f6F63C1073d55092bF95a5227fc",
        Lootbox: "0xbf2E98268c8A90eE943c6Ef8E7340F0052F26b0d",
        WBNB: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
        BUSD: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
        StakingRewards: "0x65a168cFDA8fECbCBbF197e456099893E7f9094B",
        Lottery: "0x7A16658f04c32D2df40726E3028b600D585D99A5",
        LotteryOld: "0xDDcDF8619d27cBbF12070f3B7cbE5fDe17429622",
        BNFT: "",
        Playdex: "0x959d8d3add23ff8D1F5B37D8db09a95F42f8d904",
        StakingRewardsLP: "0xdBb47Cc765B9656e8C18fa975662CC3EbF778548",
        StakingRewardsOld: "0x16108bcDC5C52a426F823FBF83aBFde763E91ABf",
        LiquidityProvider: "0x9dFf2991f531c44CE5E484bC37589D6A18d68F5E",//To check if it is still used
        MerkleBNB: "0x96eC7E2231d2274a086239916C3b3Dd7CFff91c0",
        MerkleEggHunt: "0x790402C145c49E7B0B96F73008995bBa8185ccaF",
        AirDropMerkle: "0x3dd9F75965d8D1Ad760A9B849d40560DAf56D76a",
        AirDropMerkle2: "0x3663241F0e84B85a1B58a2254aCfCA5C971f03A5",
        BuyMisteryBoxMerkle: "0xf1f7474E30e72Bf8de26c8A2b67a9d0ebF5FcBFe"

    },
    rinkeby: {
        KMONToken: "0x20317089818D87df0DE077F02df226bCB4611640",
        KMONFT: "0xbc0741f3ec450406bb8dcd24c3eed8549678d868",
        KMONFTV2: "0x5ea74a7105f9c2628abe80d3af22afb1d7ce9a46",
        MarketplaceProxy: "0x93E0dEBc0552e51Aa97340f8dcE631CEBF32E6Cb",
        ERC721Bid: "0xd87AD41E951B08a821A0Bd1BaE91cb6BF36da475",
        Lootbox: "0xE9633AEF8e63D75e5d4eF5C7B7D5466544De7DaA",
        WBNB: "0x83A7c9C8d5E2A0Ed76EdEe1aB6b2c404DbBeDA87",
        BUSD: "0xF1dF161b82e33D4FB27aa7445dE9F4c8Fe273d22",
        StakingRewards: "0xb83c69de750d61721ddbf04ba6792e653352047b",
        Lottery: "0xc825F037C0957937B8300Ce14662ac559424c44d",
        LotteryOld: "",
        BNFT: "",
        Playdex: "",
        StakingRewardsLP: "",
        StakingRewardsOld: "",
        LiquidityProvider: "",
        MerkleBNB: "",
        MerkleEggHunt: "0x10c96cB5743E888D320bd245956c6E0C904bD58e",
        AirDropMerkle: "0x358A7a85Ace067195bE3A61D1Dc0ae0Ce10F8A24",
        AirDropMerkle2: "",
        BuyMisteryBoxMerkle: ""


    },
    chapel: {
        KMONFT: "0xe65baf422bb854f71056e6ff3b74e819d77b859f",
        KMONFTV2: "0x0d205d5be22a39a870e0ba00ebe24fc1beeed932",
        KMONToken: "0xa67375293613b4E081855E605504ba54be6Af139",
        MarketplaceProxy: "0x9bc6d13fdbf796bb19434acf4715fe3396174b77",
        ERC721Bid: "0x7049d2a6369e98660a17505218b78f55f4d70dab",
        Lootbox: "0xe774326fe3caa5805421e10d70040461ee4f57be",
        WBNB: "0x3815b854ed19989736452bad899ed072b16220d1",
        BUSD: "0x250d5fd2ec844a2b238acece2ebb528ec1057693",
        StakingRewards: "0xb50d1db997e0dff09e38a12040b480bf77af13b8",
        Lottery: "0x78ca555c5397719BDFF2ce2f329764ED824e9847", //address in github doc"0x60095C8775a4d1B1e41A92A73Bc7194dC564c347",
        LotteryOld: "",
        BNFT: "0x8bF6404c80863E8bDc176099594Bf949c44c26E4",
        Playdex: "0x6f49b271C1819398Ba75Ca54b333A8cc9F922008",
        StakingRewardsLP: "",
        StakingRewardsOld: "",
        LiquidityProvider: "",
        MerkleBNB: "",
        MerkleEggHunt: "",
        AirDropMerkle: "",
        AirDropMerkle2: "",
        BuyMisteryBoxMerkle: ""

    }
}



// export const BINANCESMARTPROD = (netId): IContract[] => {
//     return [
//         {
//             name: eContracts.contractInstance,
//             abi: abi.contractAbiV4Json,
//             address: contracts.contractAddress
//         },
//         {
//             name: eContracts.contractInstanceV2,
//             abi: abi.contractAbiDiamond,
//             address: "0x04B0f7d5CB2CE4688497f2525748FB7A9aFFa394"
//         },
//         {
//             name: eContracts.contractTokenInstance,
//             abi: abi.tokenAbiJson,
//             address: contracts.tokenAddress
//         },
//         {
//             name: eContracts.contractMerkleInstance,
//             abi: abi.merkleClaimAbi,
//             address: contracts.merkleClaimAddress
//         },
//         {
//             name: eContracts.contractMerkleInstance2,
//             abi: abi.merkleClaimAbi,
//             address: contracts.merkleClaimAddress2
//         },
//         {
//             name: eContracts.contractMerkleInstance3,
//             abi: abi.merkleClaimAbi,
//             address: contracts.merkleClaimAddress3
//         },
//         {
//             name: eContracts.contractMerkleInstance4,
//             abi: abi.merkleClaimAbi,
//             address: contracts.merkleClaimAddress4
//         },
//         {
//             name: eContracts.contractMerkleEggHunt,
//             abi: abi.merkleClaimAbi,
//             address: "0x4E6c30872e8f5746C316805Aff3F9C1820DdC0b0"
//         },
//         {
//             name: eContracts.contractMerkleEggHunt2,
//             abi: abi.merkleClaimAbi,
//             address: ""
//         },
//         {
//             name: eContracts.contractAirdropMerkleInstance,
//             abi: abi.merkleAirdrop,
//             address: "0x3dd9F75965d8D1Ad760A9B849d40560DAf56D76a"
//         },
//         {
//             name: eContracts.contractLotteryInstance,
//             abi: abi.lotteryAbiJson,
//             address: contracts.lotteryAddress
//         },
//         {
//             name: eContracts.contractOldLotteryInstance,
//             abi: abi.lotteryAbiJson,
//             address: contracts.oldLotteryAddress
//         },
//         {
//             name: eContracts.contractRewardsInstance,
//             abi: abi.stakingRewardsAbiJson,
//             address: contracts.rewardsAddress
//         },
//         {
//             name: eContracts.newContractRewardsInstance,
//             abi: abi.stakingRewardsAbiJson,
//             address: contracts.newRewardsAddress
//         },
//         {
//             name: eContracts.contractMerkleLoreInstance,
//             abi: abi.merkleClaimAbi,
//             address: contracts.merkleLoreAddress
//         },
//         {
//             name: eContracts.contractMerkleLoreInstance2,
//             abi: abi.merkleClaimAbi,
//             address: contracts.merkleLoreAddress
//         },
//         {
//             name: eContracts.newContractRewardsInstanceLP,
//             abi: abi.stakingRewardsAbiJson,
//             address: contracts.newRewardsAddressLP
//         },
//         {
//             name: eContracts.contractLPInstance,
//             abi: abi.pancakeV2Pair,
//             address: contracts.LPAddress
//         },
//         {
//             name: eContracts.contractRedeemNFTInstance,
//             abi: abi.redeemNFTABI,
//             address: '0x1a1E83b6F7C39c17Bb507fbBA609e148ab50C31A'
//         },
//         {
//             name: eContracts.contractPartnerInstance,
//             abi: abi.ERC721,
//             address: '0xC4bdb04878e1B0c872bC1152751a16a968001a00'
//         },
//         {
//             name: eContracts.contractRedeemNFTInstance2,
//             abi: abi.redeemNFTABI,
//             address: '0xf32e8288F1bDC30EDb7d7CABfdcAFe669E7845f8'
//         },
//         {
//             name: eContracts.contractPartnerInstance2,
//             abi: abi.ERC721,
//             address: '0x9C4E29a6bC9759219b79E31cAcb7d5c526dAb007'
//         },
//         {
//             name: eContracts.contractBuyMysteryBoxMerkleInstance,
//             abi: abi.merkleClaimAbi,
//             address: '0xf1f7474E30e72Bf8de26c8A2b67a9d0ebF5FcBFe'
//         },
//         {
//             name: eContracts.contractBuyTokenInstance,
//             abi: abi.tokenAbiJson,
//             address: '0xe9e7cea3dedca5984780bafc599bd69add087d56'
//         },
//         {
//             name: eContracts.contractAirdropMerkleInstance2,
//             abi: abi.merkleAirdrop.abi,
//             address: "0x7274539192F0AbC654EC945BB67DE88A09fc5206"
//         },
//         {
//             name: eContracts.contractCryptoCom,
//             abi: abi.merkleClaimAbi,
//             address: "0x842f58f009ca1E7053993967b801e7930D34b579"
//         },
//         {
//             name: eContracts.contractCryptoCom2,
//             abi: abi.merkleClaimAbi,
//             address: ""
//         },
//         {
//             name: eContracts.contractMerkleMB,
//             abi: abi.merkleMBSaleAbi,
//             address: "0xe308C3C4a4debdf70278Ea628ffF113BdaD0E4B0"
//         },
//         {
//             name: eContracts.pancakeV2,
//             abi: abi.pancakeV2Abi,
//             address: "0x10ED43C718714eb63d5aA57B78B54704E256024E"
//         },
//         {
//             name: eContracts.WBNB,
//             abi: abi.BNBAbi,
//             address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"
//         },
//         {
//             name: eContracts.marketplaceContract,
//             abi: abi.marketplaceAbi,
//             address: "0x61BB68bcA6eB9DCb434A52fBCB999a353c283aFF"
//         },
//         {
//             name: eContracts.lootboxesContract,
//             abi: abi.lootboxAbi,
//             address: "0xbf2E98268c8A90eE943c6Ef8E7340F0052F26b0d"
//         },
//         //TODO
//         // {
//         //     name: eContracts.contractMBPurchaseToken,
//         //     abi: abi.tokenAbiJson,
//         //     address: contracts.purchaseToken
//         // },
//         {
//             name: eContracts.playdexContract,
//             abi: abi.playdexAbi,
//             address: "0x959d8d3add23ff8D1F5B37D8db09a95F42f8d904"
//         }
//     ]
// }

// export const RINKEBY = (): IContract[] => {
//     return [
//         {
//             name: eContracts.contractInstance,
//             abi: abi.contractAbiV4Json,
//             address: "0xBc0741f3EC450406Bb8DCD24c3eEd8549678d868"
//         },
//         {
//             name: eContracts.contractInstanceV2,
//             abi: abi.contractAbiDiamond,
//             address: "0x5eA74A7105f9c2628AbE80D3Af22Afb1d7CE9A46"
//         },
//         {
//             name: eContracts.contractMerkleEggHunt,
//             abi: abi.merkleClaimAbi,
//             address: "0x10c96cB5743E888D320bd245956c6E0C904bD58e"
//         },
//         {
//             name: eContracts.contractTokenInstance,
//             abi: abi.tokenAbiJson,
//             address: "0x9ec8ae8732a1ad3240a773617ca9048cc4cf606a"
//         },
//         {
//             name: eContracts.contractMerkleInstance,
//             abi: abi.merkleClaimAbi,
//             address: "0xEE32A3F6C239ea7E8FB0672b4B2b7Db67bd310D5"
//         },
//         {
//             name: eContracts.contractMerkleInstance2,
//             abi: abi.merkleClaimAbi,
//             address: "0xEE32A3F6C239ea7E8FB0672b4B2b7Db67bd310D5"
//         },
//         {
//             name: eContracts.contractAirdropMerkleInstance,
//             abi: abi.merkleAirdrop.abi,
//             address: "0x358A7a85Ace067195bE3A61D1Dc0ae0Ce10F8A24"
//         },
//         {
//             name: eContracts.contractLotteryInstance,
//             abi: abi.lotteryAbiJson,
//             address: "0xc825F037C0957937B8300Ce14662ac559424c44d"
//         },
//         {
//             name: eContracts.contractBuyTokenInstance,
//             abi: abi.tokenAbiJson,
//             address: ''
//         },
//         {
//             name: eContracts.contractRewardsInstance,
//             abi: abi.stakingRewardsAbiJson,
//             address: "0xe2490Fe356c6Bb695c8823c79e25945EeD440918"
//         },
//         {
//             name: eContracts.contractMerkleMB,
//             abi: abi.merkleMBSaleAbi,
//             address: "0x34746AE9A87A7e42D3f98Ffe46Df8D7D9d79dA4c"
//         },

//         // {
//         //     name: eContracts.contractMBPurchaseToken,
//         //     abi: abi.tokenAbi,
//         //     address: purchaseToken
//         // },
//         {
//             name: eContracts.contractCryptoCom,
//             abi: abi.merkleClaimAbi,
//             address: "0x1A4b031C1AC66C82F86B5263ce6240510FE358be"
//         },
//         {
//             name: eContracts.contractCryptoCom2,
//             abi: abi.merkleClaimAbi,
//             address: "0x9Fd8aab80DdEB773868Fe19CB665084bf54bB6F9"
//         },
//     ]
// }


// export const BINANCESMART = (): IContract[] => {
//     return [
//         {
//             name: eContracts.contractInstance,
//             abi: abi.contractAbiV4Json,
//             address: "0xe65bAF422bB854F71056E6Ff3B74E819d77b859f"
//         },
//         {
//             name: eContracts.contractTokenInstance,
//             abi: abi.tokenAbiJson,
//             address: "0x067B7d96bff6c924Fd1397535fb9e753861bd952"
//         },
//         {
//             name: eContracts.contractLotteryInstance,
//             abi: abi.lotteryAbiJson,
//             address: "0x78ca555c5397719BDFF2ce2f329764ED824e9847"
//         },
//         {
//             name: eContracts.contractRewardsInstance,
//             abi: abi.stakingRewardsAbiJson,
//             address: "0xa5Ac40f9De1deb41Ef1D86dbDf668233a82C1402"
//         },
//         {
//             name: eContracts.contractRedeemNFTInstance,
//             abi: abi.redeemNFTABI,
//             address: '0xB23037c569798C9b3B2D9c41024eDd76C548a8bF'
//         },
//         {
//             name: eContracts.contractPartnerInstance,
//             abi: abi.ERC721,
//             address: '0x4c2E7B35342B2a6A9c33C67E9bF24C2249f855FB'
//         },
//         {
//             name: eContracts.lootboxesContract,
//             abi: abi.lootboxAbi,
//             address: "0xe774326fe3caa5805421e10d70040461ee4f57be"
//         },
//     ]
// }